import React, { FC, useCallback, useMemo } from 'react'
import { MobilePillButton, CloseIconStyled, Container, ClearAllLink } from './styles'
import isEmpty from 'lodash/isEmpty'
import { useSelector } from 'react-redux'
import { useRequestUserConfigContext } from '../../../../hooks/request'
import { useTranslation } from '../../../../hooks/locale'
import { clearSearchRequestId, filterClear, filterClick, getActiveFilters } from '../../../../redux/filters'
import { useABVariant } from '../../../../utils/hooks'
import { AB_KEY, AB_VARIANT_VERSION } from '../../../../common/constants'
import { useAppDispatch } from '../../../../redux/hooks'

const ActiveFilterPills: FC = () => {
    const dispatch = useAppDispatch()
    const user = useRequestUserConfigContext()
    const { t } = useTranslation()
    const { isProvidedVariantActive: isBookingBannerActive } = useABVariant(
        AB_KEY.BOOKING_BANNER_SRL,
        AB_VARIANT_VERSION.ONE,
    )

    const onFilterClick = useCallback(
        (e: React.MouseEvent<HTMLButtonElement>) => {
            const encodedLink = e.currentTarget.dataset.resetLink
            if (!encodedLink) {
                return
            }

            dispatch(clearSearchRequestId())
            dispatch(filterClick(encodedLink, false, user))
        },
        [dispatch, user],
    )

    const onFilterClear = useCallback(() => {
        dispatch(filterClear(user))
    }, [dispatch, user])

    const activeFiltersSelector = useMemo(() => getActiveFilters(isBookingBannerActive), [isBookingBannerActive])
    const activeFilters = useSelector(activeFiltersSelector)

    if (isEmpty(activeFilters)) {
        return null
    }

    return (
        <Container>
            {activeFilters.map((filter, index) => (
                <MobilePillButton
                    key={`${filter.label}-${index}`}
                    data-reset-link={filter.resetLink}
                    onClick={onFilterClick}
                    isActive
                >
                    {filter.label} <CloseIconStyled />
                </MobilePillButton>
            ))}
            <ClearAllLink onClick={onFilterClear}>{t('clearAllFilters')}</ClearAllLink>
        </Container>
    )
}

export default ActiveFilterPills
